export default "__VITE_ASSET__BEdc18LV__"